"use client";
import { useContext } from "react";
import { AuthContext } from "../../../../../apps/managetrips/src/components/auth-wrapper/auth-context";
import {
  Authenticated,
  type AuthenticatedProperties,
} from "./true-blue/authenticated";
import {
  Unauthenticated,
  type UnauthenticatedProperties,
} from "./true-blue/unauthenticated";

import { enhanceUserData } from "../../../helpers/user-data/enhance-user-data";

export type HeaderTrueBlueProperties = {
  creditProfileMenu: AuthenticatedProperties["creditProfileMenu"];
  loggedInMenu: AuthenticatedProperties["loggedInMenu"];
  loggedOutMenu: UnauthenticatedProperties;
  useAuth?: boolean;
};
export const HeaderTrueBlue = ({
  creditProfileMenu,
  loggedInMenu,
  loggedOutMenu,
  useAuth,
}: HeaderTrueBlueProperties) => {
  const hasAuthToken = useContext(AuthContext).IS_TOKEN_STORED?.stored;
  const customerDetails = useContext(AuthContext).PROFILE?.customerDetails;
  const isCreditProfile = useContext(AuthContext).IS_CREDIT_PROFILE_USER;
  const isSignedIn = useAuth && hasAuthToken && customerDetails;

  return isSignedIn ? (
    <Authenticated
      creditProfileMenu={creditProfileMenu}
      // @ts-ignore
      customerDetails={enhanceUserData({ customerDetails, isCreditProfile })}
      isCreditProfile={isCreditProfile}
      loggedInMenu={loggedInMenu}
    />
  ) : (
    <Unauthenticated {...loggedOutMenu} />
  );
};

HeaderTrueBlue.displayName = "Header.TrueBlue";
